import { mainApi } from '../../../../api/mainApi';
import { middlewareApi } from '../../../middleware/middlewareApi';

import {
  AppStatus,
  GeneralApplication,
  GeneralApplicationResponse,
} from '../interfaces/generalApplications.interfaces';
import { GLobalUpdateApp } from '../interfaces/payloads.interfaces';
import { AccessState } from '../../../../types';
import { PracticeSubjectsResponse } from '../interfaces/practice-subjects.interface';

export const generalApplicationTags = middlewareApi.enhanceEndpoints({
  addTagTypes: ['Applications', 'InternalHomologation'],
});
// Define a service using a base URL and expected endpoints
export const generalApplicationApi = generalApplicationTags.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * @GET all applications
     */
    getGeneralApplications: builder.query<
      GeneralApplicationResponse,
      {
        profileId: number;
        page: number;
        perPage: number;
        search: string;
        acronym?: string;
        startDate?: string;
        endDate?: string;
        status?: string;
        facultyId?: number;
        sort?: string;
        type_sort?: string;
      }
    >({
      queryFn: async (
        {
          profileId,
          page,
          search,
          perPage,
          acronym,
          startDate,
          endDate,
          status,
          facultyId,
          sort,
          type_sort,
        },
        { dispatch }
      ) => {
        try {
          const { data } = await mainApi.get<GeneralApplicationResponse>(
            '/application/get-applications-next-status/pending',
            {
              params: {
                user_profile_id: profileId,
                page,
                size: perPage,
                type_sort: 'desc',
                search,
                acronym: acronym || '',
                start_date: startDate || undefined,
                end_date: endDate || undefined,
                status: status || undefined,
                faculty_id: facultyId || undefined,
                ...(type_sort && { type_sort }),
                ...(sort && { sort }),
              },
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: 'Applications', id } as const)),
              { type: 'Applications', id: 'LIST' },
              { type: 'InternalHomologation', id: 'LIST' },
            ]
          : [
              { type: 'Applications', id: 'LIST' },
              { type: 'InternalHomologation', id: 'LIST' },
            ],
    }),

    /**
     * @GET application by id
     */
    getGeneralApplicationHomologationById: builder.query<
      GeneralApplication,
      { profileId?: number; ApplicationHomId: number }
    >({
      queryFn: async ({ profileId, ApplicationHomId }, { getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = profileId || currentProfile?.profileId;
          const { data } = await mainApi.get<GeneralApplication>(
            `/application/${ApplicationHomId}`,
            {
              params: {
                user_profile_id,
              },
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: (result, error, { ApplicationHomId }) => [
        { type: 'Applications', id: ApplicationHomId },
        // { type: 'Applications', id: 'LIST' },
      ],
    }),

    getGeneralApplicationsStatus: builder.query<
      AppStatus[],
      {
        profileId: number;
      }
    >({
      queryFn: async ({ profileId }) => {
        try {
          const { data } = await mainApi.get<AppStatus[]>('application-status', {
            params: {
              user_profile_id: profileId,
              data: 'all',
            },
          });

          return { data: Array.isArray(data) ? data : [] };
        } catch (error: any) {
          return { error };
        }
      },
    }),

    /*realizar el mismo funcionamiento de seleccion de funciones (RejectAppDialog) de actualizacion para evitar 
    /crear mismos endpoints y solo cambiar la url
    */
    /**
     * @PUT update application third registration
     */
    updateThirdRegistrationApplication: builder.mutation<
      GLobalUpdateApp,
      { profileId: number; applicationPayload: Partial<GLobalUpdateApp>; ApplicationId: number }
    >({
      queryFn: async ({ profileId, applicationPayload }) => {
        try {
          const { data } = await mainApi.post<GLobalUpdateApp>(
            `/applications/third-registration/change-status`,
            {
              user_profile_id: profileId,
              ...applicationPayload,
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: (result, error, { ApplicationId }) => [
        { type: 'Applications', id: ApplicationId },
        // { type: 'InternalHomologation', id: 'LIST' },
      ],
    }),

    /**
     * @PUT update application subject retirement
     */
    updateSubjectRetirementApplication: builder.mutation<
      GLobalUpdateApp,
      { profileId: number; applicationPayload: Partial<GLobalUpdateApp>; ApplicationId: number }
    >({
      queryFn: async ({ profileId, applicationPayload }) => {
        try {
          const { data } = await mainApi.post<GLobalUpdateApp>(
            `/applications/subject-retirement/change-status`,
            {
              user_profile_id: profileId,
              ...applicationPayload,
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: (result, error, { ApplicationId }) => [
        { type: 'Applications', id: ApplicationId },
        // { type: 'InternalHomologation', id: 'LIST' },
      ],
    }),

    /**
     * @PUT update application requalification
     */
    updateRequalificationApplication: builder.mutation<
      GLobalUpdateApp,
      { profileId: number; applicationPayload: Partial<GLobalUpdateApp>; ApplicationId: number }
    >({
      queryFn: async ({ profileId, applicationPayload }) => {
        try {
          const { data } = await mainApi.post<GLobalUpdateApp>(
            `/applications/requalification/change-status`,
            {
              user_profile_id: profileId,
              ...applicationPayload,
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: (result, error, { ApplicationId }) => [
        { type: 'Applications', id: ApplicationId },
        // { type: 'InternalHomologation', id: 'LIST' },
      ],
    }),

    /**
     * @PUT update application requalification
     */
    updateOthersApplication: builder.mutation<
      GLobalUpdateApp,
      { profileId: number; applicationPayload: Partial<GLobalUpdateApp>; ApplicationId: number }
    >({
      queryFn: async ({ profileId, applicationPayload }) => {
        try {
          const { data } = await mainApi.post<GLobalUpdateApp>(
            `/applications/others/change-status`,
            {
              user_profile_id: profileId,
              ...applicationPayload,
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: (result, error, { ApplicationId }) => [
        { type: 'Applications', id: ApplicationId },
        // { type: 'InternalHomologation', id: 'LIST' },
      ],
    }),

    /**
     * @PUT update application practices
     */
    updatePracticeApplication: builder.mutation<
      GLobalUpdateApp,
      { profileId: number; applicationPayload: Partial<GLobalUpdateApp>; ApplicationId: number }
    >({
      queryFn: async ({ profileId, applicationPayload }) => {
        try {
          const { data } = await mainApi.post<GLobalUpdateApp>(
            `/applications/practices/change-status`,
            {
              user_profile_id: profileId,
              ...applicationPayload,
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: (result, error, { ApplicationId }) => [
        { type: 'Applications', id: ApplicationId },
        // { type: 'InternalHomologation', id: 'LIST' },
      ],
    }),

    /**
     * @PUT update application links
     */
    updateLinkApplication: builder.mutation<
      GLobalUpdateApp,
      { profileId: number; applicationPayload: Partial<GLobalUpdateApp>; ApplicationId: number }
    >({
      queryFn: async ({ profileId, applicationPayload }) => {
        try {
          const { data } = await mainApi.post<GLobalUpdateApp>(
            `/applications/links/change-status`,
            {
              user_profile_id: profileId,
              ...applicationPayload,
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: (result, error, { ApplicationId }) => [
        { type: 'Applications', id: ApplicationId },
        // { type: 'InternalHomologation', id: 'LIST' },
      ],
    }),

    /**
     * @PUT update application payment agreeement
     */
    updatePaymentAgreementApplication: builder.mutation<
      GLobalUpdateApp,
      { profileId: number; applicationPayload: Partial<GLobalUpdateApp>; ApplicationId: number }
    >({
      queryFn: async ({ profileId, applicationPayload }) => {
        try {
          const { data } = await mainApi.post<GLobalUpdateApp>(
            `/applications/payment-agreement/change-status`,
            {
              user_profile_id: profileId,
              ...applicationPayload,
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: (result, error, { ApplicationId }) => [
        { type: 'Applications', id: ApplicationId },
        // { type: 'InternalHomologation', id: 'LIST' },
      ],
    }),

    /**
     * @PUT update application internal homologation
     */
    updateInternalHomApplication: builder.mutation<
      GLobalUpdateApp,
      {
        profileId: number;
        applicationPayload: Partial<GLobalUpdateApp>;
        ApplicationId: number;
        subjects?: number[];
      }
    >({
      queryFn: async ({ profileId, applicationPayload, subjects }) => {
        try {
          const { data } = await mainApi.post<GLobalUpdateApp>(
            `/applications/internal-homologations/change-status`,
            {
              user_profile_id: profileId,
              ...applicationPayload,
              ...(subjects && { subjects }),
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: (result, error, { ApplicationId }) => [
        { type: 'Applications', id: ApplicationId },
        { type: 'InternalHomologation', id: 'LIST' },
      ],
    }),

    /**
     * @PUT update application recovery exam
     */
    updateRecoveryExamApplication: builder.mutation<
      GLobalUpdateApp,
      { profileId: number; applicationPayload: Partial<GLobalUpdateApp>; ApplicationId: number }
    >({
      queryFn: async ({ profileId, applicationPayload }) => {
        try {
          const { data } = await mainApi.post<GLobalUpdateApp>(
            `/applications/recovery-exam/change-status`,
            {
              user_profile_id: profileId,
              ...applicationPayload,
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: (result, error, { ApplicationId }) => [
        { type: 'Applications', id: ApplicationId },
        // { type: 'InternalHomologation', id: 'LIST' },
      ],
    }),

    /**
     * @PUT update application late exam
     */
    updateLateExamApplication: builder.mutation<
      GLobalUpdateApp,
      { profileId: number; applicationPayload: Partial<GLobalUpdateApp>; ApplicationId: number }
    >({
      queryFn: async ({ profileId, applicationPayload }) => {
        try {
          const { data } = await mainApi.post<GLobalUpdateApp>(
            `/applications/late-exam/change-status`,
            {
              user_profile_id: profileId,
              ...applicationPayload,
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: (result, error, { ApplicationId }) => [
        { type: 'Applications', id: ApplicationId },
        // { type: 'InternalHomologation', id: 'LIST' },
      ],
    }),

    /**
     * @PUT update application late exam
     */
    updateProfessionalPracticeApplication: builder.mutation<
      GLobalUpdateApp,
      { profileId: number; applicationPayload: Partial<GLobalUpdateApp>; ApplicationId: number }
    >({
      queryFn: async ({ profileId, applicationPayload }) => {
        try {
          const { data } = await mainApi.post<GLobalUpdateApp>(
            `/applications/approve-practices/change-status`,
            {
              user_profile_id: profileId,
              ...applicationPayload,
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: (result, error, { ApplicationId }) => [
        { type: 'Applications', id: ApplicationId },
        // { type: 'InternalHomologation', id: 'LIST' },
      ],
    }),

    //
    updateFaultJustificationApplication: builder.mutation<
      GLobalUpdateApp,
      { profileId: number; applicationPayload: Partial<GLobalUpdateApp>; ApplicationId: number }
    >({
      queryFn: async ({ profileId, applicationPayload }) => {
        try {
          const { data } = await mainApi.post<GLobalUpdateApp>(
            `/applications/justify-fault/change-status`,
            {
              user_profile_id: profileId,
              ...applicationPayload,
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: (result, error, { ApplicationId }) => [
        { type: 'Applications', id: ApplicationId },
        // { type: 'InternalHomologation', id: 'LIST' },
      ],
    }),

    updateBookReservationApplication: builder.mutation<
      GLobalUpdateApp,
      { profileId: number; applicationPayload: Partial<GLobalUpdateApp>; ApplicationId: number }
    >({
      queryFn: async ({ profileId, applicationPayload }) => {
        try {
          const { data } = await mainApi.post<GLobalUpdateApp>(
            `/applications/book-borrow/change-status`,
            {
              user_profile_id: profileId,
              ...applicationPayload,
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: (result, error, { ApplicationId }) => [
        { type: 'Applications', id: ApplicationId },
        // { type: 'InternalHomologation', id: 'LIST' },
      ],
    }),
    /**
     * @GET practice nivelations subjects
     */
    getPracticeNivelationsSubjects: builder.query<
      PracticeSubjectsResponse,
      {
        student_record_id: number | string;
        user_profile_id: number | string;
      }
    >({
      queryFn: async ({ student_record_id, user_profile_id }) => {
        try {
          const { data } = await mainApi.get<PracticeSubjectsResponse>(
            `/applications/student-record/${student_record_id}/pratice-subjects`,
            {
              params: {
                user_profile_id,
              },
            }
          );
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),
    /**
     * @POST acta de consejo
     */
    sendApplicationActa: builder.mutation<
      any,
      {
        payload: {
          user_profile_id: number;
          faculty_id: number;
          fecha: string;
          lugar: 'eco sambo';
          hora: string;
          asistentes: number[];
          fecha_ini: string;
          fecha_fin: string;
        };
      }
    >({
      queryFn: async ({ payload }) => {
        try {
          const { data } = await mainApi.post<any>(
            '/certificates/acta-solicitudes',
            {
              ...payload,
            },
            {
              responseType: 'arraybuffer',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/pdf',
              },
            }
          );
          return { data };
        } catch (error: any) {
          console.log('error', error);
          return { error };
        }
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetGeneralApplicationsQuery,
  useGetGeneralApplicationHomologationByIdQuery,
  useLazyGetGeneralApplicationHomologationByIdQuery,

  useUpdateThirdRegistrationApplicationMutation,
  useUpdateSubjectRetirementApplicationMutation,
  useUpdateRequalificationApplicationMutation,
  useUpdateOthersApplicationMutation,
  useUpdatePracticeApplicationMutation,
  useUpdateLinkApplicationMutation,
  useUpdatePaymentAgreementApplicationMutation,
  useUpdateInternalHomApplicationMutation,
  useUpdateRecoveryExamApplicationMutation,
  useUpdateLateExamApplicationMutation,
  useUpdateFaultJustificationApplicationMutation,
  useUpdateBookReservationApplicationMutation,
  useUpdateProfessionalPracticeApplicationMutation,

  useGetGeneralApplicationsStatusQuery,
  useGetPracticeNivelationsSubjectsQuery,
  useSendApplicationActaMutation,
} = generalApplicationApi;
